import { render } from "./AboutView.vue?vue&type=template&id=f946caa0&scoped=true&ts=true"
import script from "./AboutView.vue?vue&type=script&lang=ts"
export * from "./AboutView.vue?vue&type=script&lang=ts"

import "./style/about.scss?vue&type=style&index=0&id=f946caa0&lang=scss&scoped=true&external"
import "./style/animation.scss?vue&type=style&index=1&id=f946caa0&lang=scss&scoped=true&external"
import "./style/common.scss?vue&type=style&index=2&id=f946caa0&lang=scss&scoped=true&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f946caa0"]])

export default __exports__